import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ValueTextPair, ValueTextPairNumberValue } from 'src/app/shared/models/value-text-pair';
import { HistoryComponent } from '../components/order-dosage/history/history.component';
import { ReceiptComponent } from '../components/receipt/receipt.component';
import { RepeatedPrescriptionComponent } from '../components/repeated-prescription/repeated-prescription.component';
import { ReportApi } from '../reportApi';
import { RegisterComponent } from '../components/register/register.component';
import { DrugBagComponent } from '../components/drug-bag/drug-bag.component';
import { CtrdrugsContainerComponent } from '../components/ctrdrugs-container/ctrdrugs-container.component';
import { LabsOutclinicReportComponent } from '../components/labs/labs-outclinic-report/labs-outclinic-report.component';
import { HistApi } from 'src/app/services/api-service/hist/hist-api';
import { ClinicDataService } from 'src/app/services/data-service/clinic-data-service';
import { PRN001Params } from 'src/app/services/api-service/parameters/PRN001Params';
import { DynamicReciptComponent } from '../design-tools/dynamic-recipt/dynamic-recipt.component';
import { EasyNotificationService } from 'src/app/services/easy-notification.service';
import { MedicationWayAndReceiptReportComponent } from 'src/app/shared/components/report/medication-way-and-receipt-report/medication-way-and-receipt-report.component';
import { RepeatedPrescriptionDynamicComponent, RepeatedPresReportType } from '../design-tools/repeated-prescription/repeated-pres-dynamic/repeated-pres-dynamic.component';
import { ChineseReceiptInfo, CmsReportAdditionalParamter, DrugBagInfo } from 'src/app/services/api-service/hist/whole-large-hist';
import { HistOrder } from 'src/app/hist/models/hist-order';
import { ArrearReceiptComponent } from '../components/arrear-receipt/arrear-receipt.component';
import { SessionService } from 'src/app/services/session.service';
import { FunctionEnable } from 'src/app/services/base-config.service';

import { ChineseHrx, ChiReportApi } from 'src/app/services/api-service/hist/chi-report-api';
import { UserCache } from 'src/app/services/user-cache';
import { HcrService } from 'src/app/services/hcr-service.service';

@Component({
  selector: 'app-report-helper',
  templateUrl: './report-helper.component.html',
  styleUrls: ['./report-helper.component.css']
})
export class ReportHelperComponent implements OnInit {

  @ViewChild('drugbag')
  private stdDrugbag: DrugBagComponent;
  @ViewChild('receipt')
  private receipt: ReceiptComponent;
  @ViewChild('cmsReport')
  private cmsReport: DynamicReciptComponent;
  @ViewChild('cmsPresReport')
  private cmsPresReport: RepeatedPrescriptionDynamicComponent;
  @ViewChild('history')
  private history: HistoryComponent;
  // @ViewChild('way')
  // private way:MedicationWayReportComponent;
  @ViewChild('way')
  private way: MedicationWayAndReceiptReportComponent;
  @ViewChild('register')
  private register: RegisterComponent;
  @ViewChild('repPres')
  private repPres: RepeatedPrescriptionComponent;
  // @ViewChild('sampling')
  // private sampling:SamplingOrderListComponent;
  @ViewChild('ctrdrugs')
  private ctrdrugs: CtrdrugsContainerComponent;
  @ViewChild('labOutclinic')
  private labOutclinic: LabsOutclinicReportComponent;
  @ViewChild('arrearReceipt')
  private arrearReceipt: ArrearReceiptComponent;

  @ViewChild('UDTmp')
  private UDTmp: ElementRef<HTMLDivElement>;
  @ViewChild('LRTmp')
  private LRTmp: ElementRef<HTMLDivElement>;
  @ViewChild('UDLRTmp')
  private UDLRTmp: ElementRef<HTMLDivElement>;

  private reportTypes: ValueTextPairNumberValue[] = [];
  private param: PRN001Params;
  public drugBagRxIdList: HistOrder[] = [];
  private paramArr: ValueTextPair[] = [];
  private additionPrintSetting = '';
  private useOutVisit = false;
  private useOutVisitJail = false;
  customBagRules: any[] = [];
  public static Instance = null;
  constructor(
    private el: ElementRef<HTMLElement>,
    private clinicDataService: ClinicDataService,
    private api: ReportApi,
    private histApi: HistApi,
    private hcrService:HcrService,
    private chineseReportApi: ChiReportApi,
    private sessionService: SessionService,
    private notify: EasyNotificationService) {
    this.el.nativeElement.style.display = 'none';
    ReportHelperComponent.Instance = this;
  }

  async ngOnInit() {
    this.useOutVisit = this.sessionService.getData('useOutVisit');
    this.useOutVisitJail = this.sessionService.getData('useOutVisitJail');
    this.additionPrintSetting = this.sessionService.getData('additionPrintSetting');
    this.param = await this.clinicDataService.getParam("PRN001");

    if (FunctionEnable.EnableClientAdvCache) {
      this.reportTypes = (await this.clinicDataService.getEnum(['ReportType']))['ReportType'];
    } else {
      this.reportTypes = await this.api.getReportType();
    }
    var css = document.createElement('style');
    css.appendChild(document.createTextNode(
      '@media print {body {margin: 0;color: #000;background-color: #fff;}}\n' +
      '.UDLRTmp>div{width:"50%"}'
    ));
    this.UDLRTmp.nativeElement.appendChild(css);

    var css2 = document.createElement('style');
    css2.appendChild(document.createTextNode(
      '@media print {body {margin: 0;color: #000;background-color: #fff;}}\n' +
      '.LRTmp>div{width:"50%"}'
    ));
    this.LRTmp.nativeElement.appendChild(css2);

    var css3 = document.createElement('style');
    css3.appendChild(document.createTextNode(
      '@media print {body {margin: 0;color: #000;background-color: #fff;}}\n' +
      '.UDTmp>div{width:"100%"}'
    ));
    this.UDTmp.nativeElement.appendChild(css3);
    if (this.useOutVisit || this.useOutVisitJail) {   // 巡診並另外設定列印參數
      if (this.additionPrintSetting) {
        this.paramArr = [];

        try {
          // 優先使用 JSON.parse
          var parsedData = JSON.parse(this.additionPrintSetting);

          // 只取列印參數
          if (parsedData.ReceiptCode !== undefined) {
            this.paramArr.push({ text: 'ReceiptCode', value: parsedData.ReceiptCode || '' });
          }
          if (parsedData.RepeatPresCode !== undefined) {
            this.paramArr.push({ text: 'RepeatPresCode', value: parsedData.RepeatPresCode || '' });
          }
          if (parsedData.HistoryCode !== undefined) {
            this.paramArr.push({ text: 'HistoryCode', value: parsedData.HistoryCode || '' });
          }
          if (parsedData.CtrDrugsCode !== undefined) {
            this.paramArr.push({ text: 'CtrDrugsCode', value: parsedData.CtrDrugsCode || '' });
          }
        } catch (e) {
          // JSON 解析失敗,使用字串解析
          console.warn('JSON 解析失敗,使用字串解析:', e);
          var oriParam = this.additionPrintSetting.replace(/\ /g, '').replace(/\{/g, '').replace(/\}/g, '').replace(/\"/g, '');
          const strs = oriParam.split(',');
          strs.forEach(str => {
            const data = new ValueTextPair();
            if (str.indexOf(':') > 0) {
              data.text = str.split(':')[0];
              data.value = str.split(':')[1];
            } else {
              data.text = str;
              data.value = str;
            }
            // 過濾掉 EMRXmlPath
            if (data.text !== 'EMRXmlPath') {
              this.paramArr.push(data);
            }
          });
        }

        // 取值
        var recCode = this.paramArr.find(x => x.text == 'ReceiptCode')?.value;
        if (recCode && recCode.length > 0) this.param.ReceiptCode = recCode;

        var presCode = this.paramArr.find(x => x.text == 'RepeatPresCode')?.value;
        if (presCode && presCode.length > 0) this.param.RepeatPresCode = presCode;

        var histCode = this.paramArr.find(x => x.text == 'HistoryCode')?.value;
        if (histCode && histCode.length > 0) this.param.HistoryCode = histCode;

        var ctrDrugsCode = this.paramArr.find(x => x.text == 'CtrDrugsCode')?.value;
        if (ctrDrugsCode && ctrDrugsCode.length > 0) this.param.CtrDrugsCode = ctrDrugsCode;
      }
    }
  }

  /** tp:1一般處方 2收據 5連處 101掛號單*/
  public async print(regId: number, tp: number[],getHtmlParam : GetHtmlParamter = null) {
    //console.log('本地表單['+tp+']列印中...')
    this.useOutVisit = this.sessionService.getData('useOutVisit');
    this.useOutVisitJail = this.sessionService.getData('useOutVisitJail');
    this.additionPrintSetting = this.sessionService.getData('additionPrintSetting');
    this.param = await this.clinicDataService.getParam("PRN001");
    // 巡診並另外設定列印參數
    if (this.useOutVisit || this.useOutVisitJail) {
      if (this.additionPrintSetting) {
        this.paramArr = [];

        try {
          // 優先使用 JSON.parse
          var parsedData = JSON.parse(this.additionPrintSetting);

          // 只取列印參數
          if (parsedData.ReceiptCode !== undefined) {
            this.paramArr.push({ text: 'ReceiptCode', value: parsedData.ReceiptCode || '' });
          }
          if (parsedData.RepeatPresCode !== undefined) {
            this.paramArr.push({ text: 'RepeatPresCode', value: parsedData.RepeatPresCode || '' });
          }
          if (parsedData.HistoryCode !== undefined) {
            this.paramArr.push({ text: 'HistoryCode', value: parsedData.HistoryCode || '' });
          }
          if (parsedData.CtrDrugsCode !== undefined) {
            this.paramArr.push({ text: 'CtrDrugsCode', value: parsedData.CtrDrugsCode || '' });
          }
        } catch (e) {
          // JSON 解析失敗,使用字串解析
          console.warn('JSON 解析失敗,使用字串解析:', e);
          var oriParam = this.additionPrintSetting.replace(/\ /g, '').replace(/\{/g, '').replace(/\}/g, '').replace(/\"/g, '');
          const strs = oriParam.split(',');
          strs.forEach(str => {
            const data = new ValueTextPair();
            if (str.indexOf(':') > 0) {
              data.text = str.split(':')[0];
              data.value = str.split(':')[1];
            } else {
              data.text = str;
              data.value = str;
            }
            // 過濾掉 EMRXmlPath
            if (data.text !== 'EMRXmlPath') {
              this.paramArr.push(data);
            }
          });
        }

        // 取值
        var recCode = this.paramArr.find(x => x.text == 'ReceiptCode')?.value;
        if (recCode && recCode.length > 0) this.param.ReceiptCode = recCode;

        var presCode = this.paramArr.find(x => x.text == 'RepeatPresCode')?.value;
        if (presCode && presCode.length > 0) this.param.RepeatPresCode = presCode;

        var histCode = this.paramArr.find(x => x.text == 'HistoryCode')?.value;
        if (histCode && histCode.length > 0) this.param.HistoryCode = histCode;

        var ctrDrugsCode = this.paramArr.find(x => x.text == 'CtrDrugsCode')?.value;
        if (ctrDrugsCode && ctrDrugsCode.length > 0) this.param.CtrDrugsCode = ctrDrugsCode;
      }
    }

    if (tp.length == 1) {
      var html = await this.getHtml(regId, tp[0],getHtmlParam);
      var name = this.reportTypes.find(x => x.value == tp[0])?.text ?? '';
      this.printHtml(tp[0], name, html);
    } else if (tp.length == 2) {
      tp.forEach(async x => {
        var html = await this.getHtml(regId, x);
        this.LRTmp.nativeElement.innerHTML += html;
      });
      var html = this.LRTmp.nativeElement.innerHTML;
      var name = this.reportTypes.find(x => x.value == tp[0])?.text ?? '';
      this.printHtml(tp[0], name, html);
    } else {
      tp.forEach(async x => {
        var html = await this.getHtml(regId, x);
        this.UDLRTmp.nativeElement.innerHTML += html;
      });
      var html = this.UDLRTmp.nativeElement.innerHTML;
      var name = this.reportTypes.find(x => x.value == tp[0])?.text ?? '';
      this.printHtml(tp[0], name, html);
    }
  }
  /** 一頁兩格，左右 */
  public async printHorizontal(name: string, ...htmls: string[]) {
    for (let i = 0; i < htmls.length; i += 2) {
      var html = htmls[i];
      this.LRTmp.nativeElement.innerHTML = '';
      this.LRTmp.nativeElement.innerHTML += html;
      if (htmls.length <= i + 1) {
        html = htmls[i + 1];
        this.LRTmp.nativeElement.innerHTML += html;
      }
      this.printHtml(0, name, this.LRTmp.nativeElement.innerHTML);
    }
  }
  /** 一頁兩格，上下 */
  public async printVertical(name: string, ...htmls: string[]) {
    var css = document.createElement('style');
    css.appendChild(document.createTextNode(
      '@page { size: A4; margin:0cm; }\n' +
      '@media print {body {margin: 0;color: #000;background-color: #fff;}}'
    ));

    this.UDTmp.nativeElement.innerHTML = '';
    this.UDTmp.nativeElement.appendChild(css);

    for (let i = 0; i < htmls.length; i++) {
      var html = htmls[i];
      if (i % 2 == 0 && i > 0) {
        this.printHtml(999, name, this.UDTmp.nativeElement.outerHTML);
        this.UDTmp.nativeElement.innerHTML = '';
        this.UDTmp.nativeElement.appendChild(css);
      }
      this.UDTmp.nativeElement.innerHTML += html;
    }
    if (this.UDTmp.nativeElement.innerHTML != '') {
      this.printHtml(999, name, this.UDTmp.nativeElement.outerHTML);
    }
  }

  /** 叫做grid其實每頁只有4格，左上->右上->左下->右下 */
  public async printGrid(paperSize: 'A4', name: string, ...htmls: string[]) {
    var css = document.createElement('style');
    css.appendChild(document.createTextNode(
      '@page { size: A4; margin:0cm; }\n' +
      '@media print {body {margin: 0;color: #000;background-color: #fff;}}\n'
      // '.UDLRTmp>div{width:"50%"}\n'
    ));
    this.UDLRTmp.nativeElement.innerHTML = '';
    this.UDLRTmp.nativeElement.appendChild(css);

    for (let i = 0; i < htmls.length; i++) {
      var html = htmls[i];
      if (i % 4 == 0 && i > 0) {
        this.printHtml(999, name, this.UDLRTmp.nativeElement.outerHTML);
        this.UDLRTmp.nativeElement.innerHTML = '';
        this.UDLRTmp.nativeElement.appendChild(css);
      }
      this.UDLRTmp.nativeElement.innerHTML += html;
    }
    if (this.UDLRTmp.nativeElement.innerHTML != '') {
      this.printHtml(999, name, this.UDLRTmp.nativeElement.outerHTML);
    }
  }
  public async getPrePrint(regId: number, tp: number) {
    switch (tp) {
      // 病歷
      case 1:
        break;
      // 收據
      case 2:
        break;
      // 藥袋
      case 7:
        break;
      // 連處
      case 5:
        this.repPres.isopenQRcode = false;
        break;
      // 交付檢驗單
      case 6:
        break;
      case 81: // FOR Code測試 ok的話回回到一般交付調劑處方籤
        this.repPres.isopenQRcode = true;
        var res = await this.repPres.getQRCode();
        break;
      // 掛號單
      case 101:
        break;
      // 連處
      default:
        break;
    }
  }

  public async getHtml(regId: number, tp: number,param: GetHtmlParamter = null): Promise<string> {
    var rs: (v: string) => void = null;
    var prom = new Promise<string>((_rs, rj) => {
      rs = _rs;
    })

    this.cmsReport.clearReportCache();

    switch (tp) {
      // 處方
      case 1:
        if (this.param.HistoryCode) {
        if (UserCache.IsChineseMode()) {
          rs(await this.getChineseCmsHtmlByRxClass(regId, tp, this.param.HistoryCode));
        }
        else{

          // 動態收據元件
          try {
            //先抓資料再載UI UI會檢查資料決定要不要抽換
            await this.cmsReport.fetch(regId,this.param.HistoryCode)
            setTimeout(async () => {
              var html = await this.cmsReport.getHtml(tp);
              rs(html);
            }, 0);
          } catch (e) {
            this.notify.showError(e)
          }
        }
        } else {
          await this.history.setRegId(regId);
          setTimeout(() => {
            var html = this.history.getHtml();
            rs(html);
          }, 0);
        }
        break;
      // 收據
      case 2:
        this.param.ChineseDetailReceiptCode = this.param.ReceiptCode;
        if (UserCache.IsChineseMode() && this.param.ChineseDetailReceiptCode) {
          rs(await this.getChineseCmsHtmlByRxClass(regId, tp, this.param.ChineseDetailReceiptCode));
        }
        else if (this.param.ReceiptCode) {
          // 動態收據元件
          try {
            console.log('getHtml >>>>> 收據');
            //先抓資料再載UI UI會檢查資料決定要不要抽換
            await this.cmsReport.fetch(regId,this.param.ReceiptCode)
            setTimeout(async () => {
              var html = await this.cmsReport.getHtml(tp);
              rs(html);
            }, 0);
          } catch (e) {
            this.notify.showError(e)
          }
        } else {
          // 一般收據元件
          await this.receipt.setRegId(regId);
          setTimeout(() => {
            var html = this.receipt.getHtml();
            rs(html);
          }, 0);
        }

        break;
      // 服法收據
      case 3:
        if (this.param.WayCode) {
          // 動態收據元件
          try {
            //先抓資料再載UI UI會檢查資料決定要不要抽換
            await this.cmsReport.fetch(regId, this.param.WayCode)
            setTimeout(async () => {
              var html = await this.cmsReport.getHtml(tp);
              rs(html);
            }, 0);
          } catch (e) {
            this.notify.showError(e)
          }
        } else {
          // 一般收據元件
          await this.way.setRegId(regId);
          setTimeout(() => {
            var html = this.way.getHtml();
            rs(html);
          }, 0);
        }

        break;
      // 藥袋
      case 7:
        var p03 = await this.clinicDataService.getParam('PRN003')
        var isCmsDrugbag = !!p03.CustomDrugBag;

        // 判斷要列印的藥品，this.drugBagRxIdList.length == 0 => 全印
        var rxIds: number[] = [];
        if (this.drugBagRxIdList.length > 0) {
          rxIds = this.drugBagRxIdList.map(x => x.RxId);
        } else {
          rxIds.push(0);
        }

        var drugBag;
        if (isCmsDrugbag) {
          // 載入CMS取得排除規則
          var cmsDrugbagCode = p03.CustomDrugBag;
          //先抓資料再載UI UI會檢查資料決定要不要抽換
          await this.cmsReport.fetch(regId, cmsDrugbagCode);
          var hrxRules = this.cmsReport.cmsData?.hrxRule || null;

          // 呼叫API時傳遞排除規則
          drugBag = await this.histApi.getCMSDrugBag(regId, rxIds, hrxRules, this.customBagRules);
        } else {
          drugBag = await this.histApi.getDrugBag(regId, rxIds, this.customBagRules);
        }

        // 若不足 MinDaysToPrintDrugBag 設定的開藥天數, 不印藥袋
        if (!drugBag.Hrx || drugBag.Hrx.length === 0) {
          rs(''); // 返回空字串，不印任何東西
          return;
        }

        var pageNo = 1;
        var html = '';

        for (let h of drugBag.Hrx) {
          var d: DrugBagInfo = Object.assign({}, drugBag);
          d.Hrx = [h];
          d.BagNo = pageNo++;


          if (isCmsDrugbag) {
            // 根據該頁是否有慢箋藥品來決定是否保留下次領藥日
            var hasChronicDrug = h.data.some(x => x.HasChronicDrug);
            if (!hasChronicDrug) {
              d.PresDateStartAndEnds = null;  // 清空非慢箋藥袋的下次領藥日
            }

            // CMS藥袋：根據每頁的內容動態選擇模板
            var cmsDrugbagCode = p03.CustomDrugBag; // 預設使用一藥一袋模板

            // 檢查此頁面是否為多藥一袋模式
            var isMultiDrugPage = h.data.length > 1;
            // 或者檢查頁面中第一個藥品的標記
            var hasOneDrugOneBagFlag = h.data.length > 0 && h.data[0].IsOneDrugOneBagPage === false;

            // 如果有多藥一袋模板且此頁面為多藥模式，使用多藥一袋模板
            if (p03.CustomDrugBag2 && (isMultiDrugPage || hasOneDrugOneBagFlag)) {
              cmsDrugbagCode = p03.CustomDrugBag2;
            }

            // 切換藥袋模板內的過濾規則跟切換前的不一致的時候 是不是會出問題...
            const param = new CmsReportAdditionalParamter();
            param.drugBagInfo = d;
            //先抓資料再載UI UI會檢查資料決定要不要抽換
            await this.cmsReport.fetch(regId,cmsDrugbagCode, param);
          } else {
            // 一般藥袋：根據每頁的內容或FormType選擇

            // 檢查此頁面是否為多藥一袋模式
            var isMultiDrugPage = h.data.length > 1;
            var hasOneDrugOneBagFlag = h.data.length > 0 && h.data[0].IsOneDrugOneBagPage === false;

            // 動態設定此頁面的FormType
            if (drugBag.FormType === 3) {
              // 混合模式：根據藥品標記決定
              d.FormType = h.data[0].IsOneDrugOneBagPage ? 2 : 1; // 2=一藥一袋, 1=多藥一袋
            } else {
              // 保持原有FormType
              d.FormType = drugBag.FormType;
            }

            this.stdDrugbag.rxIds = rxIds;
            await this.stdDrugbag.setData(d, rxIds);
          }

          html += await new Promise<string>((a, b) => {
            setTimeout(async () => {
              if (isCmsDrugbag) {
                a(this.cmsReport.getHtml(tp));
              } else {
                a(this.stdDrugbag.getHtml());
              }
              // var h = this.stdDrugbag.getHtml();

              // a(h);
            }, 0);
          });
          // }
        };
        rs(html);

        break;
      // 連處
      case 5:
        if (this.param.RepeatPresCode) {
          // 動態收據元件
          try {
            this.cmsPresReport.setType(RepeatedPresReportType.Prescription);
            //先抓資料再載UI UI會檢查資料決定要不要抽換
            await this.cmsPresReport.setRegId(regId,param?.CurrentPres);
            await this.cmsPresReport.getReport(this.param.RepeatPresCode)
            setTimeout(async () => {
              var html = await this.cmsPresReport.getHtml();
              rs(html);
            }, 0);
          } catch (e) {
            this.notify.showError(e)
          }
        } else {
          // 一般收據元件
          await this.repPres.setRegId(regId,param?.CurrentPres);
          setTimeout(() => {
            var html = this.repPres.getHtml();
            rs(html);
          }, 0);
        }

        break;
      case 6://交付檢驗單
        if (this.param.DispExampCode) {
          try {
            this.cmsPresReport.setType(RepeatedPresReportType.DispExam);
            await this.cmsPresReport.setRegId(regId);
            await this.cmsPresReport.getReport(this.param.DispExampCode)
            setTimeout(async () => {
              var html = await this.cmsPresReport.getHtml();
              rs(html);
            }, 0);
          } catch (e) {
            this.notify.showError(e)
          }
        } else {
          await this.labOutclinic.setRegId(regId);
          setTimeout(() => {
            var html = this.labOutclinic.getHtml();
            rs(html);
          }, 0);
        }
        break;
      case 81: // FOR Code測試 ok的話回回到一般交付調劑處方籤
        await this.repPres.setRegId(regId);
        setTimeout(() => {
          var html = this.repPres.getHtml();
          rs(html);
        }, 1);
        break;
      case 101:
        if (this.param.RegisterCode) {
          // 動態收據元件
          try {
            //先抓資料再載UI UI會檢查資料決定要不要抽換
            await this.cmsReport.fetch(regId,this.param.RegisterCode)
            setTimeout(async () => {
              var html = await this.cmsReport.getHtml(tp);
              rs(html);
            }, 0);
          } catch (e) {
            this.notify.showError(e)
          }
        } else {
          // 一般收據元件
          await this.register.setRegId(regId);
          setTimeout(() => {
            var html = this.register.getHtml();
            rs(html);
          }, 0);
        }

        break;
      case 809:
        if (this.param.CtrDrugsCode) {
          try {
            this.cmsPresReport.setType(RepeatedPresReportType.CtrDrugs);
            await this.cmsPresReport.setRegId(regId);
            await this.cmsPresReport.getReport(this.param.CtrDrugsCode);
            setTimeout(async () => {
              var html = await this.cmsPresReport.getHtml();
              rs(html);
            }, 0);
          } catch (e) {
            this.notify.showError(e);
          }
        } else {
          await this.ctrdrugs.setRegId(regId);
          setTimeout(async () => {
            var html = await this.ctrdrugs.getHtml();
            //  console.log(html);
            rs(html);
          }, 0);
        }
        break;
      case 810: //欠卡單(押金單)
        if (this.param.ArrearReceiptCode) {
          try {
            //先抓資料再載UI UI會檢查資料決定要不要抽換
            await this.cmsReport.fetch(regId, this.param.ArrearReceiptCode)
            setTimeout(async () => {
              var html = await this.cmsReport.getHtml(tp);
              rs(html);
            }, 0);
          } catch (e) {
            this.notify.showError(e)
          }
        }
        else {
          await this.arrearReceipt.getHistArrearReceipt(regId);
          setTimeout(() => {
            var html = this.arrearReceipt.getHtml();
            rs(html);
          }, 0);
       
        }
        break;
      case 815://注射單
        if (this.param.InjectFormCode) {
          // 動態收據元件
          try {
            //先抓資料再載UI UI會檢查資料決定要不要抽換
            await this.cmsReport.fetch(regId, this.param.InjectFormCode)
            setTimeout(async () => {
              var html = await this.cmsReport.getHtml(tp);
              rs(html);
            }, 0);
          } catch (e) {
            this.notify.showError(e)
          }
        } else {
          this.notify.showError('未設定注射單CMS格式')
        }
        break;

      //連處
      default:
        rs('');
        break;
    }
    return prom;
  }


  /** 中醫模式：依 RxClass 分組，逐組產生收據 HTML */
  public async getChineseCmsHtmlByRxClass(regId: number, tp: number, receiptCode: string): Promise<string> {
    const receiptInfo = await this.chineseReportApi.getChineseReceiptInfo(regId);

    const groupedByRx = receiptInfo.Hrxes.reduce<Record<string, ChineseHrx[]>>((acc, item) => {
      const key = item.RxClass;
      if (!acc[key]) acc[key] = [];
      acc[key].push(item);
      return acc;
    }, {});

    var html = '';
    var page = 1;
    for (const rxKey of Object.keys(groupedByRx)) {
      this.cmsReport.page = page;
      const param = new CmsReportAdditionalParamter();
      const chineseReceiptInfo = new ChineseReceiptInfo();
      chineseReceiptInfo.chineseRxList = groupedByRx[rxKey];
      param.chineseReceiptInfo = chineseReceiptInfo;

      await this.cmsReport.fetch(regId, receiptCode, param);
      html += await new Promise<string>((resolve) => {
        setTimeout(async () => resolve(await this.cmsReport.getHtml(tp)), 0);
      });
      page++;
    }

    this.cmsReport.page = 1;
    return html;
  }

  public async printHtml(tp: number, name: string, content: string,subPrinter:number[]=null) {
    // console.log(name + ' 送印中');
    return await this.hcrService.Print(tp, {
      PrintHtml: true,
      ReportName: name,
      Html: content
    },subPrinter);
  }
}

export class GetHtmlParamter{
    CurrentPres : number
}
